<section id="section-awards-and-accreditations" class="row" #awardsAndAccreditations>
    <div class="row">
        <h2 class="heading col-xs-10 col-xs-offset-1">Awards</h2>
    </div>

    <div class="row">
        <div class="awards-and-accreditations-container col-xs-10 col-xs-offset-1">
            <div class="awards-and-accreditations-tile">
                <img class="awards-block"
                     src="../../assets/images/awards/oulook-money.png">
            </div>

            <div class="awards-and-accreditations-tile">
                <img class="awards-block"
                     src="../../assets/images/awards/group.png">
            </div>


            <div class="awards-and-accreditations-tile">
                <img class="awards-block"
                     src="../../assets/images/awards/group-2.png">
            </div>

            <div class="awards-and-accreditations-tile">
                <img class="awards-block"
                     src="../../assets/images/awards/group-3.png">
            </div>

            <div class="awards-and-accreditations-tile">
                <img class="awards-block-big"
                     src="../../assets/images/awards/design-awards-2019-finalist-badge-2.png">
            </div>

            <div class="awards-and-accreditations-tile">
                <img class="awards-block-big"
                     src="../../assets/images/awards/gptw-certified-png-hi-res-sep-19-aug-20.png">
            </div>
        </div>
    </div>

    <div class="row">
        <h2 class="heading col-xs-10 col-xs-offset-1">Accreditations</h2>
    </div>

    <div class="row">
        <div class="awards-and-accreditations-container col-xs-10 col-xs-offset-1">
            <div class="awards-and-accreditations-tile">
                <img class="center-block"
                     alt="We are a NBFC-P2P registered with RBI"
                     src="https://res.cloudinary.com/finzy/image/upload/v1539240561/awards/nbfc.png">
            </div>

            <div class="awards-and-accreditations-tile">
                <img class="center-block"
                     alt="We are a NASSCOM member"
                     src="https://res.cloudinary.com/finzy/image/upload/v1539240562/awards/nasscom.png">
            </div>

            <div class="awards-and-accreditations-tile">
                <img class="center-block"
                     alt="We are a IAMAI member"
                     src="https://res.cloudinary.com/finzy/image/upload/v1539240561/awards/iamai.png">
            </div>

            <div class="awards-and-accreditations-tile">
                <img class="center-block"
                     alt="We are a DLAI member"
                     src="https://res.cloudinary.com/finzy/image/upload/v1539240561/awards/dlai.png">
            </div>

            <div class="awards-and-accreditations-tile">
                <img class="center-block"
                     alt="We are registered with the Department Of Industrial Policy And Promotion"
                     src="https://res.cloudinary.com/finzy/image/upload/v1539240562/awards/dipp.png">
            </div>

            <div class="awards-and-accreditations-tile">
                <img class="center-block"
                     alt="We are a member of Association Of P2P Lending Platforms"
                     src="https://res.cloudinary.com/finzy/image/upload/v1539240562/awards/p2p-lending.png">
            </div>
        </div>
    </div>
</section>
